/* Pretty Stressed — componentes CRO (bundle, ahorro, cuenta atrás, entrega, barra fija). Sin dependencias. */
(function () {
  'use strict';
  var S = window.psSettings || {};
  var TZ = 'Europe/Madrid';
  var ES = String(S.locale || document.documentElement.lang || '').indexOf('es') === 0;
  var LOC = ES ? 'es-ES' : 'en-GB';
  var T = ES ? { by: 'recíbelo el ', last: 'Último día · ', order: 'Pídelo ahora y recíbelo entre el ', and: ' y el ', add: 'Añadir a la cesta', sold: 'Agotado', save: 'Te ahorras ' } : { by: 'to get it by ', last: 'Last day · ', order: 'Order now, get it ', and: ' – ', add: 'Add to cart', sold: 'Sold out', save: 'You save ' };

  /* ---------- Dinero ---------- */
  function formatMoney(cents, format) {
    format = format || S.moneyFormat || '€{{amount_with_comma_separator}}';
    var value = Number(cents) / 100;
    function fmt(n, dec, th, dp) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + dp + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }

  /* Igual que snippets/ps-anchor.liquid */
  function anchor(price, compare) {
    var out = Number(compare) || 0;
    var pct = Number(S.anchorPercent) || 0;
    if (out <= price && pct > 0 && pct < 100) {
      var raw = Math.floor((price * 100) / (100 - pct));
      out = Math.ceil((raw + 5) / 100) * 100 - 5;
      if (out <= price) out = raw;
    }
    return out > price ? out : 0;
  }

  /* ---------- Hora de Madrid ---------- */
  function madridParts(date) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short', hour12: false });
    var o = {};
    f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute, s: +o.second, wd: o.weekday };
  }
  /* Convierte una hora de pared de Madrid a un instante real */
  function madridToDate(y, m, d, h, mi) {
    var guess = Date.UTC(y, m - 1, d, h, mi);
    for (var i = 0; i < 2; i++) {
      var p = madridParts(new Date(guess));
      var asUtc = Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi);
      guess += Date.UTC(y, m - 1, d, h, mi) - asUtc;
    }
    return new Date(guess);
  }
  function isWeekend(wd) { return wd === 'Sat' || wd === 'Sun'; }

  /* Próximo corte de producción: día laborable a la hora de corte */
  function nextCutoff(now) {
    var hour = Number(S.cutoffHour) || 14;
    for (var add = 0; add < 8; add++) {
      var p = madridParts(new Date(now.getTime() + add * 864e5));
      if (isWeekend(p.wd)) continue;
      var t = madridToDate(p.y, p.m, p.d, hour, 0);
      if (t > now) return { date: t, sameDay: add === 0 };
    }
    return null;
  }

  /* ---------- Cuenta atrás ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-ps-countdown]').forEach(function (el) {
      var label = el.querySelector('[data-label]');
      var after = el.querySelector('[data-after]');
      var daysWrap = el.querySelector('[data-days-wrap]');
      /* Próxima medianoche de Madrid: la cuenta atrás se reinicia cada noche (estilo RB Poster) */
      function nextMidnight(now) {
        var p = madridParts(new Date(now.getTime() + 864e5));
        return madridToDate(p.y, p.m, p.d, 0, 0);
      }
      function offerEndDate() {
        var m = String(S.offerEnd || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
        return m ? madridToDate(+m[1], +m[2], +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59) : null;
      }
      function target(now) {
        var mid = nextMidnight(now), end = offerEndDate();
        /* Último día real de la oferta: cuenta hasta el final de verdad */
        if (end && end > now && end <= mid) return { date: end, mode: 'offer' };
        /* Resto de días: cuenta hasta medianoche ligada a la fecha de entrega, que sí cambia cada noche */
        return { date: mid, mode: 'nightly' };
      }
      var fDate = new Intl.DateTimeFormat(LOC, { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short' });
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var now = new Date();
        var t = target(now);
        var diff = Math.max(0, Math.floor((t.date - now) / 1000));
        var d = Math.floor(diff / 86400), h = Math.floor((diff % 86400) / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
        el.querySelector('[data-d]').textContent = d;
        el.querySelector('[data-h]').textContent = pad(h);
        el.querySelector('[data-m]').textContent = pad(m);
        el.querySelector('[data-s]').textContent = pad(s);
        if (daysWrap) daysWrap.hidden = d === 0;
        if (t.mode === 'offer') {
          label.textContent = T.last + (el.dataset.offerLabel || 'Offer ends in');
          after.hidden = true;
        } else {
          label.textContent = el.dataset.cutoffLabel || 'Order in the next';
          var start = isWeekend(madridParts(now).wd) ? addBusinessDays(now, 1) : now;
          after.textContent = T.by + fDate.format(addBusinessDays(start, Number(S.shipMax) || 7));
          after.hidden = false;
        }
        el.hidden = false;
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Entrega estimada ---------- */
  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      d = new Date(d.getTime() + 864e5);
      if (!isWeekend(madridParts(d).wd)) added++;
    }
    return d;
  }
  function initDelivery() {
    var now = new Date();
    var c = nextCutoff(now);
    /* Si ya pasó el corte de hoy, la producción empieza el siguiente día laborable */
    var start = c && !c.sameDay ? new Date(c.date.getTime() - 864e5) : now;
    var f = new Intl.DateTimeFormat(LOC, { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short' });
    document.querySelectorAll('[data-ps-delivery]').forEach(function (el) {
      var min = parseInt(el.dataset.min || S.shipMin || 4, 10);
      var max = parseInt(el.dataset.max || S.shipMax || 7, 10);
      if (max < min) max = min;
      var a = addBusinessDays(start, min), b = addBusinessDays(start, max);
      el.innerHTML = T.order + '<strong>' + f.format(a) + T.and + f.format(b) + '</strong>';
    });
  }

  /* ---------- Producto: bundle, ahorro, barra fija ---------- */
  function initProduct() {
    document.querySelectorAll('[data-ps-bundle]').forEach(function (bundle) {
      var sectionId = bundle.dataset.section;
      var pct = parseInt(bundle.dataset.percent || S.bogoPercent || 30, 10);
      var info = document.querySelector('product-info[data-section="' + sectionId + '"]') || bundle.closest('section') || document;
      if (info.classList) info.classList.add('ps-has-bundle');

      function qtyInput() { return document.getElementById('Quantity-' + sectionId); }
      function setQty(q) {
        var input = qtyInput();
        if (!input) return;
        input.value = q;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      function selected() { var r = bundle.querySelector('input[type="radio"]:checked'); return r ? parseInt(r.value, 10) : 1; }
      bundle.addEventListener('change', function (e) { if (e.target.matches('input[type="radio"]')) setQty(selected()); });

      function updatePrices(variant) {
        if (!variant) return;
        var p = variant.price, half = Math.round((p * pct) / 100);
        var c = anchor(p, variant.compare_at_price) || p;
        var totals = { 1: p, 2: p * 2 - half, 3: p * 3 - half };
        [1, 2, 3].forEach(function (n) {
          var b = bundle.querySelector('[data-price="' + n + '"]');
          if (b) b.textContent = formatMoney(totals[n]);
          var s = bundle.querySelector('[data-compare="' + n + '"]');
          if (s) { s.textContent = formatMoney(c * n); s.hidden = c * n <= totals[n]; }
        });
        bundle.hidden = !variant.available;
      }
      bundle._psUpdate = function (variant) { updatePrices(variant); setTimeout(function () { setQty(selected()); }, 0); };
    });

    /* Barra fija */
    document.querySelectorAll('[data-ps-sticky]').forEach(function (bar) {
      var sectionId = bar.dataset.section;
      var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
      var btn = bar.querySelector('[data-ps-sticky-btn]');
      if (!mainBtn) { bar.remove(); return; }
      var footer = document.querySelector('.footer');
      var mainVisible = true, footerVisible = false;
      function render() {
        var show = !mainVisible && !footerVisible && window.scrollY > 240;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('ps-sticky-on', show);
      }
      new IntersectionObserver(function (es) { mainVisible = es[0].isIntersecting; render(); }).observe(mainBtn);
      if (footer) new IntersectionObserver(function (es) { footerVisible = es[0].isIntersecting; render(); }, { rootMargin: '0px 0px -45% 0px' }).observe(footer);
      window.addEventListener('scroll', render, { passive: true });
      btn.addEventListener('click', function () {
        var b = document.getElementById('ProductSubmitButton-' + sectionId);
        if (!b || b.disabled) { (document.querySelector('product-info[data-section="' + sectionId + '"]') || document.body).scrollIntoView({ behavior: 'smooth' }); return; }
        b.click();
      });
      bar._psUpdate = function (variant, title) {
        var price = bar.querySelector('[data-ps-sticky-price]');
        if (variant && price) price.textContent = formatMoney(variant.price) + (variant.title && variant.title !== 'Default Title' ? ' · ' + variant.title : '');
        btn.disabled = !variant || !variant.available;
        btn.textContent = variant && variant.available ? T.add : T.sold;
      };
    });

    /* Cambio de variante (evento de Dawn) */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        document.querySelectorAll('[data-ps-bundle]').forEach(function (b) { b._psUpdate && b._psUpdate(variant); });
        document.querySelectorAll('[data-ps-sticky]').forEach(function (b) { b._psUpdate && b._psUpdate(variant); });
        document.querySelectorAll('[data-ps-lowstock]').forEach(function (el) {
          var d = variant && document.querySelector('.ps-lowstock-data [data-v="' + variant.id + '"]');
          var q = d ? parseInt(d.getAttribute('data-q'), 10) : -1, lim = parseInt(el.getAttribute('data-limit'), 10) || 5;
          if (q > 0 && q <= lim) { el.querySelector('[data-ps-lowstock-text]').textContent = (ES ? 'Solo quedan ' + q + ' en esta talla' : 'Only ' + q + ' left in this size'); el.hidden = false; }
          else el.hidden = true;
        });
        document.querySelectorAll('[data-ps-savings]').forEach(function (el) {
          if (!variant) { el.hidden = true; return; }
          var c = anchor(variant.price, variant.compare_at_price);
          if (!c) { el.hidden = true; return; }
          var saved = c - variant.price, pct = Math.floor((saved * 100) / c);
          el.innerHTML = '<span class="ps-savings__pill">-' + pct + '%</span><span>You save ' + formatMoney(saved) + '</span>';
          el.hidden = false;
        });
      });
    }
  }

  function init() { initCountdowns(); initDelivery(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Exponer para pruebas */
  window.PS = { formatMoney: formatMoney, anchor: anchor, nextCutoff: nextCutoff, madridToDate: madridToDate };
})();